import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function ModuleContentReducer(state = initialState.moduleContent, action: any) {
  switch (action.type) {
    case types.SAVE_MODULECONTENT_SUCCESS:
      return action.moduleContent;
    default:
      return state;
  }
}
